import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router';
import './theme/retro.css';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Search } from './pages/Search';
import { Browse } from './pages/Browse';
import { Artifact } from './pages/Artifact';
import { Login } from './pages/Login';
import { Submit } from './pages/Submit';
import { Edit } from './pages/Edit';
import { Me } from './pages/Me';
import { Addon } from './pages/Addon';
import { AddonUpload } from './pages/AddonUpload';
import { AddonWatch } from './pages/AddonWatch';
import Build from './pages/Build';
import { BuildPage } from './pages/BuildPage';
import { ModQueue } from './pages/ModQueue';
import { AdminLayout } from './pages/admin/AdminLayout';
import { Overview } from './pages/admin/Overview';
import { Users } from './pages/admin/Users';
import { Artifacts } from './pages/admin/Artifacts';
import { Content } from './pages/admin/Content';
import { Seed } from './pages/admin/Seed';
import { AddonUploads } from './pages/admin/AddonUploads';
import { Builds as AdminBuilds } from './pages/admin/Builds';
import { Characters as AdminCharacters } from './pages/admin/Characters';
import { Audit } from './pages/admin/Audit';
import { NotFound } from './pages/NotFound';
import { Privacy } from './pages/legal/Privacy';
import { Terms } from './pages/legal/Terms';
import { Dmca } from './pages/legal/Dmca';
import { CharacterPage } from './pages/CharacterPage';
import { Characters } from './pages/Characters';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/search" element={<Search />} />
            <Route path="/browse/:type" element={<Browse />} />
            <Route path="/login" element={<Login />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/me" element={<Me />} />
            <Route path="/build" element={<Build />} />
            <Route path="/build/:id" element={<BuildPage />} />
            <Route path="/addon" element={<Addon />} />
            <Route path="/addon/upload" element={<AddonUpload />} />
            <Route path="/addon/watch" element={<AddonWatch />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/dmca" element={<Dmca />} />
            <Route path="/character/:region/:realm/:name" element={<CharacterPage />} />
            <Route path="/mod" element={<ModQueue />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="users" element={<Users />} />
              <Route path="artifacts" element={<Artifacts />} />
              <Route path="content" element={<Content />} />
              <Route path="seed" element={<Seed />} />
              <Route path="addon" element={<AddonUploads />} />
              <Route path="builds" element={<AdminBuilds />} />
              <Route path="characters" element={<AdminCharacters />} />
              <Route path="audit" element={<Audit />} />
            </Route>
            <Route path="/:type/:slug/edit" element={<Edit />} />
            <Route path="/:type/:slug" element={<Artifact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
